import { ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
export default function YourSeamlessMigrationStartsHere() {
  return <section className="relative w-full min-h-[70vh] flex items-center justify-center bg-background overflow-hidden">
      {}
      <div className="absolute inset-0 bg-gradient-to-br from-primary-light-background via-background to-secondary-light-background opacity-60" />
      
      {}
      <div className="absolute top-20 left-10 size-32 rounded-full bg-primary/10 blur-3xl" />
      <div className="absolute bottom-20 right-10 size-40 rounded-full bg-secondary/10 blur-3xl" />
      
      <div className="relative z-10 max-w-7xl mx-auto px-6 lg:px-8 py-20 lg:py-28">
        <div className="text-center space-y-8 animate-fade-in-up">
          {}
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-display font-bold text-foreground tracking-tight leading-snug">
            Your Seamless Migration
            <br />
            <span className="text-primary">Starts Here</span>
          </h1>
          
          {}
          <p className="text-lg md:text-xl text-foreground/80 max-w-3xl mx-auto leading-relaxed animate-fade-in-up-delay-100">
            Migrate from Microsoft Dynamics GP to Dynamics 365 Business Central with precision, speed, and audit-ready results. 
            Fast, reliable ERP migration across North America — trusted by mid-sized businesses in Canada and the U.S.
          </p>
          
          {}
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4 pt-4 animate-fade-in-up-delay-200">
            <Link to="/ContactPage">
              <Button size="lg" className="bg-primary hover:bg-primary-hover text-white shadow-medium group">
                Start Your Migration
                <ArrowRight className="ml-2 size-5 transition-transform duration-[var(--duration-fast)] group-hover:translate-x-1" />
              </Button>
            </Link>
            
            <Link to="/PricingPage">
              <Button variant="outline" size="lg" className="shadow-soft hover:shadow-medium">
                View Pricing Tiers
              </Button>
            </Link>
          </div>
          
          {}
          <div className="pt-8 flex flex-col items-center gap-3 animate-fade-in-up-delay-200">
            <p className="text-sm text-foreground/60 font-medium uppercase tracking-wider">
              Trusted Across North America
            </p>
            <div className="flex items-center gap-8 text-foreground/50">
              <span className="text-sm">🇨🇦 Canada</span>
              <span className="text-sm">•</span>
              <span className="text-sm">🇺🇸 United States</span>
            </div>
          </div>
        </div>
      </div>
    </section>;
}